import { Form, Input } from 'antd'
import { FC } from 'react'

interface OldNumProps {}

const OldNum: FC<OldNumProps> = () => {
    return (
        <Form.Item label={'Старый номер формы'} name={'oldNum'}>
            <Input />
        </Form.Item>
    )
}

export default OldNum
